import React, { useEffect, useState } from "react";

const nextDelay = () => 45000 + Math.random() * 45000;

export default function HalloweenLightning() {
  const [strike, setStrike] = useState(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    let timer;
    const schedule = (ms) => {
      timer = setTimeout(() => {
        setStrike((s) => s + 1);
        schedule(nextDelay());
      }, ms);
    };
    schedule(nextDelay());
    return () => clearTimeout(timer);
  }, []);

  if (!strike) return null;

  return (
    <div key={strike} className="hk-lightning" aria-hidden="true" data-testid="halloween-lightning">
      <div className="hk-lightning-sky" />
      <svg className="hk-lightning-bolt" viewBox="0 0 100 300" aria-hidden="true">
        <path d="M58 0 L34 118 L52 114 L28 300 L76 136 L56 142 L80 30 Z" />
      </svg>
    </div>
  );
}
